/* global grecaptcha */
import Validator from '@titanio/validator'
import analytics from '@titanio/tracker/ga'

class BaseForm {
  constructor ({ target, recaptcha }) {
    this.form =
      typeof target !== 'string' ? target : document.querySelector(target)

    if (!this.form) return

    this.state = {
      submited: false
    }

    this.instance = Validator
    this.recaptcha = recaptcha

    /**
     * used to removeListener to work
     */
    this.onFormSubmitHandler = this.onFormSubmit.bind(this)
    this.addFormEvents()
  }

  addFormEvents () {
    this.addValidator(false)
    this.form.addEventListener('submit', this.onFormSubmitHandler, false)
  }

  resetFormEvents () {
    this.form.removeEventListener('submit', this.onFormSubmitHandler, false)
  }

  addValidator (live = true) {
    this.validator = new Validator(this.form, {}, live)
    this.validate()
  }

  onFormSubmit (event) {
    event.preventDefault()

    if (!this.state.submited) {
      this.addValidator()
      this.state.submited = true
    }

    if (!this.validator.validate()) {
      this.invalid()
      return
    }

    if (this.recaptcha) {
      grecaptcha.execute()
      return
    }

    this.request()
  }

  invalid () {
    const { trackerType } = this.form.dataset
    if (!trackerType) return

    analytics.send({
      type: 'event',
      category: trackerType,
      action: `failed+${this.validator
        .getErrors()
        .map((error) => error.input.name)
        .join('+')}`
    })
  }

  /** override method
   */
  validate () {
    throw new Error(
      `validator() method is required in the form ${this.form.id}`
    )
  }

  /** override method
   */
  request () {
    throw new Error(`request() method is required in the form ${this.form.id}`)
  }
}

export default BaseForm
